import { render, staticRenderFns } from "./CustomerDashModalCancelBooking.vue?vue&type=template&id=cff5328c&scoped=true"
import script from "./CustomerDashModalCancelBooking.vue?vue&type=script&lang=js"
export * from "./CustomerDashModalCancelBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff5328c",
  null
  
)

export default component.exports